import { render, staticRenderFns } from "./diffTable.vue?vue&type=template&id=288f9581&scoped=true&"
import script from "./diffTable.vue?vue&type=script&lang=js&"
export * from "./diffTable.vue?vue&type=script&lang=js&"
import style0 from "./diffTable.vue?vue&type=style&index=0&id=288f9581&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f9581",
  null
  
)

export default component.exports